import { useMemo } from 'react';
import { useGetPlacesByName } from '../_features/deliveries/api/get-places-by-name';
import type { IPlacesNames } from '../_features/deliveries/types';
import type { IDropdownOptions } from '@/Interfaces/Data';

function usePlaces({
  placeName,
  cityId,
}: {
  placeName?: string;
  cityId?: string;
}) {
  const {
    data: places,
    isLoading,
    isFetching,
  } = useGetPlacesByName(
    { placeName, cityId },
    {
      enabled: !!placeName || !!cityId,
      staleTime: 1000 * 60 * 5,
    },
  );

  const placesOptions = useMemo(() => {
    if (places) {
      if (!places.length) return [];
      return places.map((item: IPlacesNames) => ({
        key: item._id,
        text: item.nomeExibicao,
        value: item._id,
      }));
    }
    return [];
  }, [places]);

  const placesOptionsWithAll = useMemo(() => {
    const options: IDropdownOptions[] = [
      {
        key: 'all',
        text: 'Todos',
        value: 'all',
      },
    ];
    if (places) {
      if (!places.length) return options;
      const placesOptions = places.map((item: IPlacesNames) => ({
        key: item._id,
        text: item.nomeExibicao,
        value: item._id,
      }));

      options.push(...placesOptions);

      return options;
    }
    return options;
  }, [places]);

  return { places, isLoading, isFetching, placesOptions, placesOptionsWithAll };
}

export { usePlaces };
